import inputTypes from "constants/form/inputTypes";

const answerFields = [
  {
    className: "mb-3",
    inputType: inputTypes.TEXTAREA,
    key: "answer",
    labelText: "Description",
    placeHolder: "Enter Your Answer",
    rules: { required: true },
  },
  {
    className: "pb-3",
    inputType: inputTypes.FILE,
    key: "image",
    labelText: "Image:",
    multiple: false,
  },
];

export default answerFields;
